import PropTypes from 'prop-types';
import { DownloadIcon, toast } from '@utilities';

import { downloadPowerPointFile } from '@utilities/powerpoint';

const DownloadPowerPoint = ({ customFileName, data, downloadLabel, onDownload }) => {
  const handleDownload = async () => {
    try {
      await (onDownload || downloadPowerPointFile)({ customFileName, data });
    } catch (error) {
      console.error('Error generating PowerPoint:', error);
      toast.error('Unable to download PowerPoint. Please try again.');
    }
  };

  return (
    <button
      aria-label="Download PowerPoint"
      data-testid="download-powerpoint-button"
      onClick={handleDownload}
    >
      <DownloadIcon />
      <span>.PPT File - {downloadLabel || 'Current Tab'}</span>
    </button>
  );
};

DownloadPowerPoint.propTypes = {
  customFileName: PropTypes.string,
  data: PropTypes.shape({
    chart: PropTypes.shape({
      format: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
      series: PropTypes.arrayOf(
        PropTypes.shape({
          data: PropTypes.array.isRequired,
          name: PropTypes.string.isRequired,
        })
      ).isRequired,
      xAxis: PropTypes.shape({
        categories: PropTypes.arrayOf(PropTypes.string).isRequired,
      }),
    }),
    data: PropTypes.arrayOf(PropTypes.object),
    exportName: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
    reportDateRange: PropTypes.arrayOf(PropTypes.string),
    reportName: PropTypes.string.isRequired,
    reportType: PropTypes.string.isRequired,
    reportUrl: PropTypes.string.isRequired,
    shopperAttributes: PropTypes.object,
    tabId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  downloadLabel: PropTypes.string,
  onDownload: PropTypes.func,
};

export default DownloadPowerPoint;
